export const CouponInputTestId = {
    BUTTON_CONTAINER: 'button-container',
    BUTTON_RIGHT: 'button-right',
    INPUT: 'input',
    ERROR_TEXT: 'error-text',
};
